import { NgModule } from "@angular/core";
import {
  CommonModule,
  BrokerApiKeyModule as CommonBrokerApiKeyModule,
} from "common";
import { FacilityListComponent } from "./features/facility-list/facility-list.component";
import { SharedModule } from "../../shared/shared.module";
import { FacilitiesRoutingModule } from "./facilities-routing.module";
import { FacilityDetailsComponent } from "./features/facility-details.component/facility-details.component";

@NgModule({
  declarations: [FacilityListComponent, FacilityDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    FacilitiesRoutingModule,
    CommonBrokerApiKeyModule,
  ]
})
export class FacilitiesModule {}
